import { faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src';
import { Link } from 'react-router-dom';

import type { Appointment } from '../../../../react-query/useAppointments';
import { mixpanelEvents, useTrackEvent } from '../../../../utils/mixpanel';

interface ReviewFindingsButtonProps {
  onReviewRadiographs?: () => void;
  appointment: Appointment;
  annotatorUri?: string;
  source?:
    | 'daily-dashboard'
    | 'daily-dashboard-huddle-hidden'
    | 'patient-details-sheet';
}

export const ReviewFindingsButton = ({
  onReviewRadiographs,
  appointment,
  annotatorUri,
  source,
}: ReviewFindingsButtonProps) => {
  const isReviewed = appointment.viewed;
  const { trackEvent } = useTrackEvent();

  const handleClick = () => {
    trackEvent(mixpanelEvents.reviewButtonClick, {
      source: source ?? 'unknown',
    });
    onReviewRadiographs?.();
  };

  return (
    <Link
      to={annotatorUri}
      onClick={handleClick}
      className="findings-review vai-block vai-w-full"
    >
      <Button
        className="vai-cursor-pointer vai-w-full"
        variant={isReviewed ? 'completed' : 'default'}
        aria-label={isReviewed ? 'View Reviewed Findings' : 'Review Findings'}
        data-testid="review-button"
        name="Review"
      >
        <span className="vai-hidden xl:vai-inline">
          {isReviewed ? <Trans>Reviewed</Trans> : <Trans>Review</Trans>}
        </span>
        <FontAwesomeIcon icon={isReviewed ? faCheck : faArrowRight} />
      </Button>
    </Link>
  );
};
